import { Tag } from "@bounce/design-system"
import { useFormatDecimals, useTranslation } from "@bounce/i18n"
import { useStoreReviewCount } from "@bounce/store"

import type { NearbyStorageSpot } from "@/libs/bounce/stores/types"

import StarIcon from "@bounce/assets/icons/Star-filled.svg"

type StoreRatingSecondaryProps = {
  store: Pick<NearbyStorageSpot, "rating" | "reviewCount">
}

export const StoreRating = ({ store }: StoreRatingSecondaryProps) => {
  const { t } = useTranslation()
  const reviewCount = useStoreReviewCount({ store })
  const formatDecimals = useFormatDecimals({ minDecimalPlaces: 1, maxDecimalPlaces: 2 })

  if (!store.rating) {
    return <Tag bgColor="lilac" className="tag" size="small" text={t("cmp.storeRating.new", "NEW")} />
  }
  const ratingText = formatDecimals(store.rating) + " (" + reviewCount + ")"

  return (
    <Tag
      bgColor="neutral"
      icon={<StarIcon className="mr-0.5 text-neutral-900" />}
      className="tag"
      size="small"
      text={ratingText}
    />
  )
}
